import { useAccountVerification, useQueryParam } from '@psyomics/ui-common';
import { VerificationCodeStep } from '@psyomics/ui-components';

import { useGetServiceUserQuery } from '../../account/hooks/use-get-service-user-query';

const AccountVerification = () => {
  const redirect = useQueryParam('redirect');
  const [serviceUser, fetching] = useGetServiceUserQuery();
  const { deliveryAddress, handleCodeSubmit, handleResend } = useAccountVerification({
    method: 'email',
    redirect,
    serviceUser,
  });

  if (fetching) return null;
  if (!deliveryAddress) throw new Error('no email');

  return <VerificationCodeStep deliveryAddress={deliveryAddress} onResend={handleResend} onSubmit={handleCodeSubmit} />;
};

export { AccountVerification };
